import React from 'react'
import { Flex } from '@chilipiper/design-system'
import { useProfilePictureUrl } from '../../api-queries/personal-details'
import { useMessageFeedContext } from '../../chat-widget/MessageFeedContext'
import { Block as BlockType, LiveMessageBlock } from '../../chat-data/types'
import { StyledAvatarImage } from '../styles'
import { StyledStickyAvatar } from './styles'
import { BlockRender } from './BlockRender'

interface Props {
  block: BlockType
  onLiveMessageVisible: (event: LiveMessageBlock) => void
}

const noneLiveChatBlockTypes = ['ReplyButtons', 'StartLiveChat', 'SystemMessage']

const getIsOwnMessage = (block: BlockType, guestId?: string) => {
  if (block.type === 'Message' || block.type === 'LiveMessage') {
    return block.author === `${guestId}_guest`
  }
  if (block.author === 'bot') {
    return false
  }
  // regular blocks should be considered own message and displayed without avatar
  return true
}

const dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
})
export const FeedBlock = ({ block, onLiveMessageVisible }: Props) => {
  const { guestId, orgDetails, tenantId } = useMessageFeedContext()

  const isOwnMessage = getIsOwnMessage(block, guestId)
  const isChiliPiperUser = block.author !== 'bot' && block.author !== `${guestId}_guest`
  const displayAvatarImage = !noneLiveChatBlockTypes.includes(block.type) && !isOwnMessage
  const { data: assigneePicture } = useProfilePictureUrl(
    tenantId,
    isChiliPiperUser ? block.author : ''
  )

  return (
    <Flex flexDirection='column'>
      <Flex
        alignContent='start'
        w='100%'
        justifyContent={isOwnMessage ? 'end' : 'start'}
        alignItems='end'
        title={
          block.type === 'LiveMessage' || block.type === 'Message'
            ? dateTimeFormatter.format(new Date(block.timestamp))
            : undefined
        }
      >
        {displayAvatarImage && (
          <StyledStickyAvatar mr={3} flexShrink={0}>
            <StyledAvatarImage
              src={
                (isChiliPiperUser
                  ? (assigneePicture?.url ?? orgDetails?.logo)
                  : orgDetails?.logo) || undefined
              }
              alt=''
              borderWidth='0'
            />
          </StyledStickyAvatar>
        )}
        <BlockRender
          block={block}
          isOwnMessage={isOwnMessage}
          onLiveMessageVisible={onLiveMessageVisible}
        />
      </Flex>
    </Flex>
  )
}
